import Button from "@app/components/button";
import GradientContainer from "@app/components/gradient/gradient-container";
import Input from "@app/components/input";
import { frontendApi } from "@app/lib/api";
import { useState } from "react";
import { toast } from "react-toastify";

const JoinUsSectionBottomContent = () => {
  const [email, setEmail] = useState<string>('');

  const handleSubscribe = async () => {
    const res = await frontendApi.post('web/signup-newsletter', { email })
    .then((res) => [true, res.data.message])
    .catch((err) => [false, err.response?.data?.message ?? 'Something went wrong'])
    .finally(() => setEmail(''))
    if (res[0]) {
      toast.success(res[1]);
    }
  }

  return (
    <GradientContainer overrideClassName="flex justify-center">
      <div className="grid grid-cols-12 max-w-[1200px] my-16 mx-8 md:m-12 lg:m-20 gap-y-8 md:gap-x-8 text-light">
        <div className="col-span-12 md:col-span-6 flex flex-col items-end gap-y-2">
          <span className="mobile-h3 md:h3 w-full text-center md:text-left">
            Sign up for our newsletter.
          </span>
          <span className="text-body-lg xs:subheading w-full text-center md:text-left">
            Be the first to know about everything we have.
          </span>
        </div>
        <div className="col-span-12 md:col-span-6 text-text-color-mid-em">
          <div className="xl:min-w-[500px] flex flex-col lg:flex-row items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <Input
              inputClassName="text-body-md xs:text-body-lg xs:h-12 mt-0 text-center md:text-left"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <div className="w-full xs:hidden">
              <Button
                buttonType="secondary-light"
                full
                onClick={handleSubscribe}
              >
                Subscribe
              </Button>
            </div>
            <div className="w-full lg:w-auto hidden xs:block">
              <Button
                size="xl"
                buttonType="secondary-light"
                full
                onClick={handleSubscribe}
              >
                Subscribe
              </Button>
            </div>
          </div>
        </div>
      </div>
    </GradientContainer>
  );
};

export default JoinUsSectionBottomContent;
